export const ScreenType = {
    // flat panels are currently unsupported
    FlatPanel: 0,
    Projector: 1,
    UltraShortThrow: 2
}

export const ScreenConfig = {
    epson_qb_1000B: {
        id: "epson_qb_1000B",
        name: "Epson QB-1000B",
        type: ScreenType.Projector,
        throwRatioMin: 1.35,
        throwRatioMax: 2.84,
        gltf: "assets/models/Beamer_Epson_LS12000/EpsonLS12000.gltf",
        // dimensions of the projector in cm
        size: [52.0, 45.0, 19.3],
        screenRange: [100, 500],
        aspectRatios: [ "16:9", "21:9" ],
        url: "https://www.cinedream.be/shop/epson/epson-qb1000-4k-eshift-laser-projector-isf-gekalibreerd",
    },
    epson_ls_12000: {
        id: "epson_ls_12000",
        name: "Epson LS-12000",
        type: ScreenType.Projector,
        throwRatioMin: 1.35,
        throwRatioMax: 2.84,
        gltf: "assets/models/Beamer_Epson_LS12000/EpsonLS12000.gltf",
        // dimensions of the projector in cm
        size: [52.0, 45.0, 19.3],
        screenRange: [100, 500],
        aspectRatios: [ "16:9", "21:9" ],
        url: "https://www.cinedream.be/shop/epson/epson-ls12000b-4k-eshift-ii-laser-projector",
    },
    epson_ls_12000w: {
        id: "epson_ls_12000w",
        name: "Epson LS-11000 White",
        type: ScreenType.Projector,
        throwRatioMin: 1.35,
        throwRatioMax: 2.84,
        gltf: "assets/models/Beamer_Epson_LS12000/EpsonLS12000w.gltf",
        // dimensions of the projector in cm
        size: [52.0, 45.0, 19.3],
        screenRange: [100, 500],
        aspectRatios: [ "16:9", "21:9" ],
        url: "https://www.cinedream.be/shop/epson/epson-ls11000w-4k-eshift-ii-laser-projector",
    },
    jvc_nz500: {
        id: "jvc_nz500",
        name: "JVC NZ500",
        type: ScreenType.Projector,
        throwRatioMin: 1.34,
        throwRatioMax: 2.14,
        gltf: "assets/models/Beamer_JVCDLAN5/Beamer_JVCDLAN5_001.gltf",
        // dimensions of the projector in cm
        size: [50, 23.4, 49.5],
        screenRange: [100, 500],
        aspectRatios: [ "16:9", "21:9" ],
        url:"https://www.cinedream.be/shop/jvc/jvc-dla-nz500-4k-native-laser-projector-isf-gecalibreerd",
    },
    jvc_nz700: {
        id: "jvc_nz700",
        name: "JVC NZ700",
        type: ScreenType.Projector,
        throwRatioMin: 1.34,
        throwRatioMax: 2.14,
        gltf: "assets/models/Beamer_JVCDLAN5/Beamer_JVCDLAN5_001.gltf",
        // dimensions of the projector in cm
        size: [50, 23.4, 49.5],
        screenRange: [100, 500],
        aspectRatios: [ "16:9", "21:9" ],
        url: "https://www.cinedream.be/shop/jvc/jvc-dla-nz700-4k-native-laser-projector-isf-gecalibreerd",
    },
    jvc_nz800: {
        id: "jvc_nz800",
        name: "JVC NZ800",
        type: ScreenType.Projector,
        throwRatioMin: 1.43,
        throwRatioMax: 2.92,
        gltf: "assets/models/Beamer_JVCDLAN5/Beamer_JVCDLAN5_001.gltf",
        // dimensions of the projector in cm
        size: [50, 23.4, 49.5],
        screenRange: [100, 500],
        aspectRatios: [ "16:9", "21:9" ],
        url: "https://www.cinedream.be/shop/jvc/jvc-dla-nz800-8k-e-shiftx-laser-projector",
    },
    jvc_nz900: {
        id: "jvc_nz900",
        name: "JVC NZ900",
        type: ScreenType.Projector,
        throwRatioMin: 1.35,
        throwRatioMax: 2.75,
        gltf: "assets/models/Beamer_JVCDLAN5/Beamer_JVCDLAN5_001.gltf",
        // dimensions of the projector in cm
        size: [50, 23.4, 49.5],
        screenRange: [100, 500],
        aspectRatios: [ "16:9", "21:9" ],
        url: "https://www.cinedream.be/shop/jvc/jvc-dla-nz900-8k-e-shiftx-laser-projector-isf-gecalibreerd",
    },
    sony_vplxw5000es: {
        id: "sony_vplxw5000es",
        name: "Sony VPLXW5000ES",
        type: ScreenType.Projector,
        throwRatioMin: 1.38,
        throwRatioMax: 2.21,
        screenRange: [ 152.4, 762.0 ],
        gltf: "assets/models/Beamer_Sony_VPLXW5000ES/SonyVPLXW5000ES.gltf",
        // dimensions of the projector in cm
        size: [46.9, 20.0, 47.1],
        aspectRatios: [ "16:9", "21:9" ],
        url: "https://www.cinedream.be/shop/sony/sony-vpl-xw5000es-4k-native-laser-projector-isf-gecalibreerd",
    },
    sony_vplxw5000esw: {
        id: "sony_vplxw5000esw",
        name: "Sony VPLXW5000ES White",
        type: ScreenType.Projector,
        throwRatioMin: 1.38,
        throwRatioMax: 2.21,
        screenRange: [ 152.4, 762.0 ],
        gltf: "assets/models/Beamer_Sony_VPLXW5000ES/SonyVPLXW5000ESW.gltf",
        // dimensions of the projector in cm
        size: [46.9, 20.0, 47.1],
        aspectRatios: [ "16:9", "21:9" ],
        url: "https://www.cinedream.be/shop/sony/sony-vpl-xw5000es-4k-native-laser-projector-isf-gecalibreerd",
    },
    sony_vplxw6100es: {
        id: "sony_vplxw6100es",
        name: "Sony VPLXW6100ES - Bravia 8",
        type: ScreenType.Projector,
        throwRatioMin: 1.35,
        throwRatioMax: 2.84,
        screenRange: [ 152.4, 762.0 ],
        gltf: "assets/models/Beamer_Sony_VPLXW5000ES/SonyVPLXW7000ES.gltf",
        // dimensions of the projector in cm
        size: [46.0, 21.1, 51.5],
        aspectRatios: [ "16:9", "21:9" ],
        url: "https://www.cinedream.be/shop/sony/sony-bravia-8-vpl-xw6100es-4k-native-laser-projector-isf-gecalibreerd",
    },
    sony_vplxw6100esw: {
        id: "sony_vplxw6100esw",
        name: "Sony VPLXW6100ES White - Bravia 8",
        type: ScreenType.Projector,
        throwRatioMin: 1.35,
        throwRatioMax: 2.84,
        screenRange: [ 152.4, 762.0 ],
        gltf: "assets/models/Beamer_Sony_VPLXW5000ES/SonyVPLXW7000ESW.gltf",
        // dimensions of the projector in cm
        size: [46.0, 21.1, 51.5],
        aspectRatios: [ "16:9", "21:9" ],
        url: "https://www.cinedream.be/shop/sony/sony-bravia-8-vpl-xw6100es-4k-native-laser-projector-isf-gecalibreerd",
    },
    sony_vplxw8100es: {
        id: "sony_vplxw8100es",
        name: "Sony VPLXW8100ES - Bravia 9",
        type: ScreenType.Projector,
        throwRatioMin: 1.35,
        throwRatioMax: 2.84,
        screenRange: [ 152.4, 762.0 ],
        gltf: "assets/models/Beamer_Sony_VPLXW5000ES/SonyVPLXW7000ES.gltf",
        // dimensions of the projector in cm
        size: [46.0, 21.1, 51.5],
        aspectRatios: [ "16:9", "21:9" ],
        url: "https://www.cinedream.be/shop/sony/sony-bravia-9-xw-8100es-laser-4k-native-laser-projector-isf-gekalibreerd",
    },
    sony_vplxw8100esw: {
        id: "sony_vplxw8100esw",
        name: "Sony VPLXW8100ES White - Bravia 9",
        type: ScreenType.Projector,
        throwRatioMin: 1.35,
        throwRatioMax: 2.84,
        screenRange: [ 152.4, 762.0 ],
        gltf: "assets/models/Beamer_Sony_VPLXW5000ES/SonyVPLXW7000ESW.gltf",
        // dimensions of the projector in cm
        size: [46.0, 21.1, 51.5],
        aspectRatios: [ "16:9", "21:9" ],
        url: "https://www.cinedream.be/shop/sony/sony-bravia-9-xw-8100es-laser-4k-native-laser-projector-isf-gekalibreerd",
    },
    epson_ls800: {
        id: "epson_ls800",
        name: "Epson LS800",
        type: ScreenType.UltraShortThrow,
        // fixed throw ratio for UST projector, so min = max
        throwRatioMin: 0.16,
        throwRatioMax: 0.40,
        gltf: "assets/models/Beamer_Optoma001/Beamer_OptomaUHZ65UST_001.gltf",
        size: [49.8, 15.2, 33.0],
        aspectRatios: [ "16:9" ],
        // limits of the screen sizes (if absent, there are no limits) [min, max]
        screenRange: [ 220, 270 ],
        // required for short throw, this is the vertical offset to calculate screen height.
        offset: 1.24,
        // required for short throw, this is the projector's mirror height to calculate screen height. Some specs show
        // this as the height to the projection angle. If not known, approximate by height / 2.
        mirrorHeight: 8.29,
        url: "https://www.cinedream.be/shop/epson/epson-ls800-4k-ust-3-laser-projector",
    },
    awol_ltv3000pro: {
        id: "awol_ltv3000pro",
        name: "Awol LTV-3000 PRO",
        type: ScreenType.UltraShortThrow,
        // fixed throw ratio for UST projector, so min = max
        throwRatioMin: 0.25,
        throwRatioMax: 0.25,
        gltf: "assets/models/Beamer_Optoma001/Beamer_OptomaUHZ65UST_001.gltf",
        size: [49.8, 15.2, 33.0],
        aspectRatios: [ "16:9" ],
        // limits of the screen sizes (if absent, there are no limits) [min, max]
        screenRange: [ 220, 270 ],
        // required for short throw, this is the vertical offset to calculate screen height.
        offset: 1.24,
        // required for short throw, this is the projector's mirror height to calculate screen height. Some specs show
        // this as the height to the projection angle. If not known, approximate by height / 2.
        mirrorHeight: 8.29,
        url: "https://www.cinedream.be/shop/awol-vision/awol-vision-ltv-3000-pro-4k-uhd-3d-triple-laser-projector",
    },
    awol_ltv3500pro: {
        id: "awol_ltv3500pro",
        name: "Awol LTV-3500 PRO",
        type: ScreenType.UltraShortThrow,
        // fixed throw ratio for UST projector, so min = max
        throwRatioMin: 0.25,
        throwRatioMax: 0.25,
        gltf: "assets/models/Beamer_Optoma001/Beamer_OptomaUHZ65UST_001.gltf",
        size: [49.8, 15.2, 33.0],
        aspectRatios: [ "16:9" ],
        // limits of the screen sizes (if absent, there are no limits) [min, max]
        screenRange: [ 220, 330 ],
        // required for short throw, this is the vertical offset to calculate screen height.
        offset: 1.24,
        // required for short throw, this is the projector's mirror height to calculate screen height. Some specs show
        // this as the height to the projection angle. If not known, approximate by height / 2.
        mirrorHeight: 8.29,
        url: "https://www.cinedream.be/shop/awol-vision/awol-vision-ltv-3500-pro-4k-uhd-3d-triple-laser-projector",
    },
    /*lg_hu85ls: {
        id: "lg_hu85ls",
        name: "LG HU85 LS",
        type: ScreenType.UltraShortThrow,
        // fixed throw ratio for UST projector, so min = max
        throwRatioMin: 0.19,
        throwRatioMax: 0.19,
        gltf: "assets/models/Beamer_LG_HU85LS/Beamer_LG_HU85LS_001.gltf",
        size: [68.0, 12.8, 34.7],
        aspectRatios: [ "16:9" ],
        // limits of the screen sizes (if absent, there are no limits) [min, max]
        screenRange: [ 228.6, 304.8 ],
        // required for short throw, this is the vertical offset to calculate screen height.
        offset: 1.20,
        mirrorHeight: 6.4,
        url: "https://www.cinedream.be/shop/lg/lg-hu85ls-4k-ust-laser-projector",
    },*/
    samsung_lsp7t: {
        id: "samsung_lsp7t",
        name: "Samsung LSP7T",
        type: ScreenType.UltraShortThrow,
        // fixed throw ratio for UST projector, so min = max
        throwRatioMin: 0.189,
        throwRatioMax: 0.189,
        gltf: "assets/models/Beamer_Samsung_LSP9T/Beamer_Samsung_LSP9T_001.gltf",
        size: [55.0, 14.1, 36.7],
        aspectRatios: [ "16:9" ],
        // limits of the screen sizes (if absent, there are no limits) [min, max]
        screenRange: [ 254, 330 ],
        // required for short throw, this is the vertical offset to calculate screen height.
        offset: 1.20,
        // required for short throw, this is the projector's mirror height to calculate screen height.
        // if not known, approximate by height / 2
        mirrorHeight: 10.19,
        url: "https://www.cinedream.be/shop/samsung/samsung-ultra-short-throw-premiere-lsp7t",
    },
    samsung_lsp9t: {
        id: "samsung_lsp9t",
        name: "Samsung LSP9T",
        type: ScreenType.UltraShortThrow,
        // fixed throw ratio for UST projector, so min = max
        throwRatioMin: 0.189,
        throwRatioMax: 0.189,
        gltf: "assets/models/Beamer_Samsung_LSP9T/Beamer_Samsung_LSP9T_001.gltf",
        size: [55.0, 14.1, 36.7],
        aspectRatios: [ "16:9" ],
        // limits of the screen sizes (if absent, there are no limits) [min, max]
        screenRange: [ 254, 330 ],
        // required for short throw, this is the vertical offset to calculate screen height.
        offset: 1.20,
        // required for short throw, this is the projector's mirror height to calculate screen height.
        // if not known, approximate by height / 2
        mirrorHeight: 10.19,
        url: "https://www.cinedream.be/shop/samsung/samsung-ultra-short-throw-premiere-lsp9t",
    },
};
